import { LoadingOutlined } from "@ant-design/icons";
import { notification } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authUpdateDetails } from "../../apiservice/authService";
import useFormatApiRequest from "../../hooks/formatApiRequest";
import useAuth from "../../hooks/useAuth";
import { useAppDispatch, useAppSelector } from "../../Redux/reduxCustomHook";
import { RootState } from "../../Redux/store";
import { NotificationType } from "../../utils/mscType.type";
import "./User-Profile-Comp.css";
import { IAuthType } from "../../apiservice/authService.type";

const UserProfileUpdateComp = () => {
  const [formLoading, setFormLoading] = useState<boolean>(false);
  const [loadApi, setLoadApi] = useState(false);
  const [user, setUser] = useState<any>({});
  const [api, contextHolder] = notification.useNotification();
  const [loadAuth, setLoadAuth] = useState(true);

  const authUserData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  const authState = useAuth(loadAuth, () => {
    setLoadAuth(false);
  });

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setUser({
      firstName: authUserData?.data?.credentials?.firstName,
      lastName: authUserData?.data?.credentials?.lastName,
      phoneNumber: authUserData?.data?.credentials?.phoneNumber,
    });
  }, [authUserData]);

  const handleInputChange = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;
    setUser((values: any) => ({ ...values, [name]: value }));
  };

  const handleSubmit = (event: any) => {
    event.preventDefault();
    setLoadApi(true);
    setFormLoading(true);
  };

  const result = useFormatApiRequest(
    () => authUpdateDetails(user),
    loadApi,
    () => {
      setLoadApi(false);
    },
    () => {
      processApi();
    }
  );

  const processApi = async () => {
    if (result.httpState === "SUCCESS") {
      setFormLoading(false);
      openNotificationWithIcon(
        "info",
        "",
        "Profile Updated Successfully",
        "#D9FFB5"
      );
      setLoadAuth(true);
    } else if (result.httpState === "ERROR") {
      setFormLoading(false);
      openNotificationWithIcon(
        "info",
        "",
        result.data?.response?.data?.errors?.[0]?.code ||
          result.data?.response?.data?.message ||
          result.errorMsg ||
          "Error",
        "#FFC2B7"
      );
    }
  };

  const openNotificationWithIcon = (
    type: NotificationType,
    message: string,
    description: string,
    background?: string
  ) => {
    api[type]({
      message,
      description,
      placement: "bottomRight",
      style: { background },
    });
  };

  return (
    <>
      {contextHolder}

      <div className="grid p-4">
        <form onSubmit={handleSubmit}>
          {/* First Name */}
          <div className="relative w-full mb-8">
            <label className="absolute -top-3 left-3 text-blue-800 dark:text-blue-400 px-1 bg-stone-100 dark:bg-stone-900 text-sm">
              {" "}
              {/* Assuming page bg is stone-100 light / stone-900 dark */}
              First Name
            </label>
            <input
              required
              name="firstName"
              value={
                user?.firstName || authUserData?.data?.credentials?.firstName
              }
              onChange={handleInputChange}
              type="text"
              className="pl-10 pr-4 py-2 border border-blue-800 dark:border-blue-400 rounded-lg w-full h-16 bg-transparent text-black dark:text-stone-100 placeholder-gray-500 dark:placeholder-stone-400"
              placeholder="Enter First Name"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-blue-800 dark:text-blue-400">#</span>
            </div>
          </div>

          {/* Last Name */}
          <div className="relative w-full mb-8">
            <label className="absolute -top-3 left-3 text-blue-800 dark:text-blue-400 px-1 bg-stone-100 dark:bg-stone-900 text-sm">
              Last Name
            </label>
            <input
              required
              name="lastName"
              value={
                user?.lastName || authUserData?.data?.credentials?.lastName
              }
              onChange={handleInputChange}
              type="text"
              className="pl-10 pr-4 py-2 border border-blue-800 dark:border-blue-400 rounded-lg w-full h-16 bg-transparent text-black dark:text-stone-100 placeholder-gray-500 dark:placeholder-stone-400"
              placeholder="Enter Last Name"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-blue-800 dark:text-blue-400">#</span>
            </div>
          </div>

          {/* Phone Number */}
          <div className="relative w-full mb-8">
            <label className="absolute -top-3 left-3 text-blue-800 dark:text-blue-400 px-1 bg-stone-100 dark:bg-stone-900 text-sm">
              Phone Number
            </label>
            <input
              required
              name="phoneNumber"
              value={
                user?.phoneNumber ||
                authUserData?.data?.credentials?.phoneNumber
              }
              onChange={handleInputChange}
              type="tel"
              className="pl-10 pr-4 py-2 border border-blue-800 dark:border-blue-400 rounded-lg w-full h-16 bg-transparent text-black dark:text-stone-100 placeholder-gray-500 dark:placeholder-stone-400"
              placeholder="Enter Phone Number"
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-blue-800 dark:text-blue-400">#</span>
            </div>
          </div>

          {/* Submit Button */}
          <div className="mb-2">
            <button className="w-full h-16 font-sans bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 text-white rounded-xl text-lg">
              {!formLoading ? (
                "Update Profile"
              ) : (
                <LoadingOutlined rev={undefined} />
              )}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default UserProfileUpdateComp;
